import PageTitle from "components/PageTitle";

const Header = () => <PageTitle title="Bot Network Users" />;

export default Header;
